export const ERROR_CODES = {
    201:'Información inválida',
    301:'Error con el servidor o base de datos',
    402:'El correo electrónico ya está en uso',
    106:'Correo y/o contraseña incorrectos'
}